import classNames from "classnames";
import React, { useEffect, useState } from "react";
import type { SortBy, SortOrder } from "../../common/types/Sort";
import Dropdown from "./Dropdown";
import "./SortItemsBy.css";
import { Flex } from "./Flex";
import Icon from "./Icon";

type Entries<T> = [T, string][];

type SortOrderProps = {
    entries: Entries<SortBy>;
    initialSortOrder: SortOrder;
    initialSortBy: SortBy;
    onChange: (by: SortBy, order: SortOrder) => void;
    className?: string;
};

const SortItemsBy = function SortItemsBy(props: SortOrderProps) {
    const { className, entries, initialSortOrder, initialSortBy, onChange } = props;
    const [sortOrder, setSortOrder] = useState<SortOrder>(initialSortOrder);
    const [sortBy, setSortBy] = useState<SortBy>(initialSortBy);

    useEffect(() => {
        setSortOrder(initialSortOrder);
        setSortBy(initialSortBy);
    }, [initialSortOrder, initialSortBy]);

    return (
        <Flex.Row gap="medium" className={classNames("sort-by", className)}>
            {sortOrder === "asc" ? (
                <div
                    onClick={() => {
                        setSortOrder("desc");
                        onChange(sortBy, "desc");
                    }}
                >
                    <Icon.ArrowDownward.Medium.N50 />
                </div>
            ) : (
                <div
                    onClick={() => {
                        setSortOrder("asc");
                        onChange(sortBy, "asc");
                    }}
                >
                    <Icon.ArrowUpward.Medium.N50 />
                </div>
            )}
            <Dropdown
                entries={entries}
                currentValue={sortBy}
                onChange={(sort) => {
                    setSortBy(sort as SortBy);
                    onChange(sort as SortBy, sortOrder);
                }}
            />
        </Flex.Row>
    );
};

export default SortItemsBy;
